import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { TimesIcon } from '../Icons';
import Button from '../Button';

const ConfirmModal = ({ title, message, cancel, confirm, onSuccess, onCancel, onClose, className, content }) => {
  const [fetching, setFetch] = useState(false);
  const options = useSelector(state => state.options);

  const handleConfirmClick = async () => {
    if (fetching) return;
    setFetch(true);
    if (onSuccess) await onSuccess(options);
    setFetch(false);
    onClose();
  };

  return (
    <div
      className={`confirm-modal d-flex flex-column justify-content-between py-md-40 py-30 px-8 px-md-40 mx-8 ${className}`}
    >
      <button className='btn p-0 modal-close' onClick={onClose}>
        <TimesIcon />
      </button>
      {title && <h1 className='text-center mb-md-15 mb-10'>{title}</h1>}
      {message && <p className='text-center mb-12 mb-md-15'>{message}</p>}
      {content && content}
      {(cancel || confirm) && (
        <div className='d-flex align-items-center justify-content-center'>
          {cancel && (
            <Button type='button' className={'btn-sm mx-8 btn-outline-primary'} onClick={onCancel || onClose}>
              {cancel}
            </Button>
          )}
          {confirm && (
            <Button
              type='button'
              disabled={fetching}
              onClick={handleConfirmClick}
              className={'btn-sm mx-8 px-15 px-md-10 btn-primary'}
            >
              {confirm}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default ConfirmModal;
